import React from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';


import Tilt from 'react-parallax-tilt';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import { useDisclosure } from '@mantine/hooks';
import { Modal, Button } from '@mantine/core';
import FaucetForm from './faucetForm';
import CountComp from '../../components/global/counts';
import AccordionComp from '../../components/global/accordion';
import NetworkSwapBtn from '../../auth/networkSwapBtn';
import Auth from '../../auth/authWindow';
import { useState } from 'react';
import { toggleAuthWindow } from '../../store/schemas/authSlice';
import NetworkButton from '../../components/global/networkButton';
const FaucetPromo = () => {
    const dispatch = useDispatch();
    const [opened, { open, close }] = useDisclosure(false);
    const [authOpened, { authOpen, authClose }] = useDisclosure(false);
    const currentSelectedChain = useSelector(state => state.mainapp.chainSlice.currentChain);
    const connected = useSelector(state => state.mainapp.authSlice.metamask.connected);
    const isOnChain = useSelector(state => state.mainapp.authSlice.metamask.isOnChain);
    const [renderAuth, setRenderAuth] = useState(false)
    const authWindow = useSelector(state => state.mainapp.authSlice.authWindow)
    const chainMatch = useSelector(state => state.mainapp.authSlice.metamask.chainMatch);



    return (
        <>

            {
                authWindow && <Auth />
            }

            <div className='hero-sectional' style={{
                margin: '12vh 0px'
            }}>
                <div className='on-intro vivify fadeIn duration-300' style={{ gap: '7px' }}>
                    <div style={
                        {
                            maxWidth: '760px',
                        }
                    } className='on-intro-text'>
                        <h1>
                            Pluri Faucet on <span>{currentSelectedChain.name} </span>
                        </h1>
                        <p>The Pluri faucet is a resource for users to obtain Pluri tokens. Regularly claiming from the faucet allows you to participate more effectively in the Pluri ecosystem.</p>

                    </div>
                    <div className='on-button' style={{ margin: '10px 0px', display: 'flex', flexDirection: 'column', gap: 20, justifyContent: 'center', alignItems: 'center' }}>


                        <NetworkButton classes={'hero-button'}>
                            <button onClick={open} className='hero-button'>Claim Pluri</button>
                        </NetworkButton>
                      
                    </div>

                </div>

            </div>

            <CountComp
                /*  title={<h1>
                     Simple <span>Setup</span>
                 </h1>}
 
                 description={"Becoming a stakeholder is a simple process that requires you to get the required Pluri, stake it, and earn rewards."}
  */
                items={
                    [
                        {
                            value: "Import Pluri Token Address",
                            description: "To see earnings, import the Pluri token address into your wallet.  " + currentSelectedChain?.scan?.coin?.address,

                        },
                        {
                            value: "Connect With Metamask",
                            description: "To claim from the faucet, you need to connect your wallet to the Pluri website.",

                        },
                        {
                            value: "Claim From Faucet",
                            description: "Once you have connected your wallet, you can claim Pluri tokens from the faucet.",

                        }
                    ]
                }
            />

            <AccordionComp
                /* title={<h1>What is <span>Pluri?</span></h1>}
                description={"Pluri Coin offers a way to connect data directly with transactional info on the blockchain. It provides benefits to developers by offloading database costs and simplifying payments, to investors by offering opportunities for staking and coin generation, and to ordinary users by ensuring data protection and freedom. Discover more with us."} */
                items={[
                    {
                        value: 'Why should I become a stakeholder?',
                        description: "Being a Pluri stakeholder provides a profitable investment opportunity with assured regular rewards, stability and transparency, and a strong emphasis on data integrity and security."
                    },
                    {
                        value: "What is Pluri?",
                        description: "Pluri Coin offers a way to connect data directly with transactional info on the blockchain. It provides benefits to developers by offloading database costs and simplifying payments, to investors by offering opportunities for staking and coin generation, and to ordinary users by ensuring data protection and freedom."
                    },
                    {
                        value: 'How do I earn rewards?',
                        description: "As a Pluri stakeholder, you will earn rewards for staking your Pluri. The rewards will be automatically delivered to your wallet. You can learn more about the rewards and how they are calculated in the tokenomics and epoch details."
                    },
                    {
                        value: 'How does unstaking work?',
                        description: "Unstaking your Pluri is a simple process that requires you to unstake your Pluri and wait for the unstaking period to end. Once the unstaking period ends, you can withdraw your Pluri and rewards from the staking contract."
                    }
                ]}

            />


            <ClientOnly >
                {() => (
                    <>

                        <Modal size="xl" radius={17} opened={opened} onClose={close} title="Faucet" centered>
                            <FaucetForm />
                        </Modal>

                    </>

                )}

            </ClientOnly>




        </>
    );
};

export default FaucetPromo;
